if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.wfGallery(); /* wf 261007: ook desktop */
      }

      /* wf 261006 stap2 */
      wfGallery() {
        const c = this.querySelector('[role="document"]');
        if (!this.wfCount) {
          const dialog = this.querySelector('[role="dialog"]');
          const arrow = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg>';
          const button = (cls, label, dir) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'wf-zoom-nav ' + cls;
            b.setAttribute('aria-label', label);
            b.innerHTML = arrow;
            b.addEventListener('click', () => c.scrollBy({ left: dir * c.clientWidth, behavior: 'smooth' }));
            return b;
          };
          this.wfCount = document.createElement('div');
          this.wfCount.className = 'wf-zoom-count';
          this.wfPrev = button('wf-zoom-nav--prev', 'Vorige foto', -1);
          this.wfNext = button('wf-zoom-nav--next', 'Volgende foto', 1);
          dialog.append(this.wfCount, this.wfPrev, this.wfNext);
          c.addEventListener('scroll', () => this.wfUpdate(), { passive: true });
          /* wf 261007 desktop: thumbnails, pijltjestoetsen, klik = inzoomen */
          this.wfThumbs = document.createElement('div');
          this.wfThumbs.className = 'wf-zoom-thumbs';
          dialog.append(this.wfThumbs);
          // Dawn sluit media-modal bij elke muis-pointerup; niet bij pijlen, thumbnails en de foto zelf
          [this.wfPrev, this.wfNext, this.wfThumbs, c].forEach((el) => el.addEventListener('pointerup', (e) => e.stopPropagation()));
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.wfPrev.click();
            if (e.key === 'ArrowRight') this.wfNext.click();
          });
          c.addEventListener('click', (e) => {
            const img = e.target.closest('img');
            if (!img || window.matchMedia('(max-width: 749px)').matches) return;
            const r = img.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
            img.classList.toggle('wf-zoomed');
          });
        }
        if (!this.wfThumbs.children.length && window.matchMedia('(min-width: 750px)').matches) {
          [...c.children].filter((el) => el.offsetWidth > 0).forEach((el, i) => {
            const src = el.tagName === 'IMG' ? el.currentSrc || el.src : el.querySelector('img')?.src;
            if (!src) return;
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Foto ' + (i + 1));
            b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
            b.addEventListener('click', () => c.scrollTo({ left: i * c.clientWidth, behavior: 'smooth' }));
            this.wfThumbs.append(b);
          });
        }
        // thumbnailmaat = wat in de breedte past (max 256px / 28% hoogte), foto vult de rest
        const n = this.wfThumbs.children.length;
        if (n) {
          const th = Math.min(256, innerHeight * 0.28, (innerWidth - 56 - 8 * (n - 1)) / n);
          this.querySelector('[role="dialog"]').style.setProperty('--wf-th', th + 'px');
        }
        const active = c.querySelector('.active');
        c.scrollLeft = active ? active.offsetLeft : 0;
        this.wfUpdate();
      }

      wfUpdate() {
        const c = this.querySelector('[role="document"]');
        const n = [...c.children].filter((el) => el.offsetWidth > 0).length;
        const i = Math.round(c.scrollLeft / c.clientWidth);
        this.wfCount.textContent = i + 1 + ' / ' + n;
        this.wfPrev.disabled = i <= 0;
        this.wfNext.disabled = i >= n - 1;
        [...this.wfThumbs.children].forEach((b, x) => b.classList.toggle('is-active', x === i));
        if (this.wfIdx !== i) c.querySelectorAll('.wf-zoomed').forEach((el) => el.classList.remove('wf-zoomed'));
        this.wfIdx = i;
        // desktop: pijlen direct naast de zichtbare foto (object-fit contain → echte breedte uit verhouding)
        const img = [...c.children].filter((el) => el.offsetWidth > 0)[i];
        if (img && img.naturalWidth && window.matchMedia('(min-width: 750px)').matches) {
          const w = Math.min(img.clientWidth, (img.clientHeight * img.naturalWidth) / img.naturalHeight);
          const x = Math.max(16, (c.clientWidth - w) / 2 - 76) + 'px';
          this.wfPrev.style.left = x;
          this.wfNext.style.right = x;
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
